function Credits(props){
    return (
        <div className="bg-yanisallali-1/10-black w-full text-center text-semi-less tablet:text-base py-6">
            © Copyright 2025, tous droits réservés par VIDZY
        </div>
    )
}

export default Credits;